import React from "react";
import { Modal, Spinner } from "reactstrap";
import { useHistory } from "react-router-dom";

import { useFeatures } from "../../../../hooks/features";
import { useActiveProduct } from "../../../../hooks/activeProduct";
import { urlAuditoriaPedido } from "../../AuditoriaPedido/regras";
import { fmtBRL, fmtInt, fmtData, fmtDataHora } from "./formatos";

// Modal de detalhe de uma célula do Cotado × Realizado (decisão do kickoff de
// 24/10/2026: clique abre modal, com "Abrir na auditoria" que troca o produto
// para o Flow). Sem FLOW o botão não aparece.
//   tipo = cte | pedido | nf | duplicado | cobertura
export const ROTA_AUDITORIA_CTE = "/app/flow/operacao/auditoria-cte";

const CLASSE_ROTULO = { acima: "Acima", abaixo: "Abaixo", dentro: "Dentro", semCalculo: "Sem cálculo", complemento: "Complemento" };

function CteTable({ itens, mostrarSimulado, abrirAuditoria }) {
  return (
    <table className="cr-detail-table">
      <thead>
        <tr>
          <th>CT-e</th>
          <th>Série</th>
          <th>Emissão</th>
          <th>Transportadora</th>
          <th>UF</th>
          <th className="num">Frete</th>
          {mostrarSimulado ? <th className="num">Simulado</th> : null}
          {mostrarSimulado ? <th>Situação</th> : null}
          <th>Pedido</th>
          {abrirAuditoria ? <th /> : null}
        </tr>
      </thead>
      <tbody>
        {itens.map((r, i) => (
          <tr key={`${r.numero}-${r.serie}-${i}`}>
            <td>{r.numero}</td>
            <td>{r.serie}</td>
            <td>{fmtData(r.emissao)}</td>
            <td>{r.transportadora || "—"}</td>
            <td>{r.uf || "—"}</td>
            <td className="num">{fmtBRL(r.valor)}</td>
            {mostrarSimulado ? <td className="num">{r.simulado === null || r.simulado === undefined ? "—" : fmtBRL(r.simulado)}</td> : null}
            {mostrarSimulado ? <td>{CLASSE_ROTULO[r.classe] || r.classe || "—"}</td> : null}
            <td>{r.pedido || "—"}</td>
            {abrirAuditoria ? (
              <td>
                {r.pedido ? (
                  <button type="button" className="cr-link-btn" onClick={() => abrirAuditoria("pedido", r.pedido)}>
                    Auditoria do pedido
                  </button>
                ) : null}
              </td>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function PedidoTable({ itens, abrirAuditoria }) {
  return (
    <table className="cr-detail-table">
      <thead>
        <tr>
          <th>Pedido</th>
          <th>Mês</th>
          <th>Transportadora</th>
          <th>UF</th>
          <th className="num">Cotado</th>
          <th className="num">Realizado</th>
          <th className="num">Diferença</th>
          <th className="num">CT-es</th>
          <th className="num">NFs</th>
          <th>Cotação</th>
          {abrirAuditoria ? <th /> : null}
        </tr>
      </thead>
      <tbody>
        {itens.map((r) => (
          <tr key={r.pedido}>
            <td>{r.pedido}</td>
            <td>{r.mes}</td>
            <td>{r.transportadora || "—"}</td>
            <td>{r.uf || "—"}</td>
            <td className="num">{r.cotado === null || r.cotado === undefined ? "—" : fmtBRL(r.cotado)}</td>
            <td className="num">{fmtBRL(r.realizado)}</td>
            <td className={`num${Number(r.diferenca) > 0 ? " cr-celula--danger" : ""}`}>
              {r.diferenca === null || r.diferenca === undefined ? "—" : fmtBRL(r.diferenca)}
            </td>
            <td className="num">{fmtInt(r.ctes)}</td>
            <td className="num">{fmtInt(r.nfs)}</td>
            <td>{r.numeroCotacao || "—"}</td>
            {abrirAuditoria ? (
              <td>
                <button type="button" className="cr-link-btn" onClick={() => abrirAuditoria("pedido", r.pedido)}>
                  Abrir na auditoria
                </button>
              </td>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function NfTable({ itens, abrirAuditoria }) {
  return (
    <table className="cr-detail-table">
      <thead>
        <tr>
          <th>NF</th>
          <th>Série</th>
          <th>Emissão</th>
          <th>Transportadora</th>
          <th>UF</th>
          <th className="num">Valor</th>
          <th>Pedido</th>
          {abrirAuditoria ? <th /> : null}
        </tr>
      </thead>
      <tbody>
        {itens.map((r, i) => (
          <tr key={`${r.numero}-${r.serie}-${i}`}>
            <td>{r.numero}</td>
            <td>{r.serie}</td>
            <td>{fmtData(r.emissao)}</td>
            <td>{r.transportadora || "—"}</td>
            <td>{r.uf || "—"}</td>
            <td className="num">{fmtBRL(r.valor)}</td>
            <td>{r.pedido || "—"}</td>
            {abrirAuditoria ? (
              <td>
                {r.pedido ? (
                  <button type="button" className="cr-link-btn" onClick={() => abrirAuditoria("pedido", r.pedido)}>
                    Auditoria do pedido
                  </button>
                ) : null}
              </td>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function DuplicadoTable({ itens }) {
  return (
    <table className="cr-detail-table">
      <thead>
        <tr>
          <th>CT-e</th>
          <th>Série</th>
          <th>Emissão</th>
          <th>Transportadora</th>
          <th>UF</th>
          <th className="num">Valor</th>
          <th className="num">Tentativas</th>
          <th>Primeira tentativa</th>
        </tr>
      </thead>
      <tbody>
        {itens.map((r, i) => (
          <tr key={`${r.numero}-${r.serie}-${i}`}>
            <td>{r.numero}</td>
            <td>{r.serie}</td>
            <td>{fmtData(r.emissao)}</td>
            <td>{r.transportadora || "—"}</td>
            <td>{r.uf || "—"}</td>
            <td className="num">{fmtBRL(r.valor)}</td>
            <td className="num">{fmtInt(r.tentativas)}</td>
            <td>{fmtDataHora(r.primeiraTentativa)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function CoberturaTable({ itens }) {
  return (
    <table className="cr-detail-table">
      <thead>
        <tr>
          <th>Transportadora</th>
          <th>UF</th>
          <th>Cidade</th>
          <th className="num">CT-es sem cálculo</th>
          <th className="num">Valor</th>
          <th className="num">Cotações spot</th>
          <th className="num">Valor</th>
        </tr>
      </thead>
      <tbody>
        {itens.map((r, i) => (
          <tr key={`${r.transportadora}-${r.uf}-${r.cidade}-${i}`}>
            <td>{r.transportadora}</td>
            <td>{r.uf}</td>
            <td>{r.cidade}</td>
            <td className="num">{fmtInt(r.ctesSemCalculo)}</td>
            <td className="num">{fmtBRL(r.valorCtesSemCalculo)}</td>
            <td className="num">{fmtInt(r.cotacoesSpot)}</td>
            <td className="num">{fmtBRL(r.valorCotacoesSpot)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const ROTULO_TIPO = { cte: "CT-e(s)", pedido: "pedido(s)", nf: "nota(s) fiscal(is)", duplicado: "CT-e(s) duplicado(s)", cobertura: "destino(s)" };

export default function DetalheCelulaModal({ aberto, onFechar, titulo, subtitulo, tipo, loading, erro, dados, mostrarSimulado }) {
  const history = useHistory();
  const { codes } = useFeatures();
  const { activeProduct, setActiveProduct } = useActiveProduct();
  const temFlow = Boolean(codes && codes.has && codes.has("FLOW"));

  // Troca o produto para o Flow e navega (padrão do sino de alertas).
  const abrirAuditoria = temFlow
    ? (alvo, pedido) => {
        if (activeProduct !== "FLOW") setActiveProduct("FLOW");
        onFechar();
        history.push(alvo === "pedido" ? urlAuditoriaPedido(pedido) : ROTA_AUDITORIA_CTE);
      }
    : null;

  const itens = (dados && dados.itens) || [];
  const total = dados ? Number(dados.total || 0) : 0;

  return (
    <Modal isOpen={aberto} toggle={onFechar} size="xl" modalClassName="modal-align-top cr-detail-modal" fade={false}>
      <div className="cr-detail-header">
        <div>
          <h4>{titulo}</h4>
          {subtitulo ? <small>{subtitulo}</small> : null}
        </div>
        <button type="button" className="cr-detail-close" onClick={onFechar} aria-label="Fechar">
          ×
        </button>
      </div>
      <div className="cr-detail-body">
        {loading ? (
          <div className="cr-loading">
            <Spinner color="info" />
          </div>
        ) : null}
        {!loading && erro ? (
          <div className="cr-state cr-state--error">
            <strong>Erro:</strong> {erro}
          </div>
        ) : null}
        {!loading && !erro && dados && itens.length === 0 ? <div className="cr-state">Nenhum item encontrado.</div> : null}
        {!loading && !erro && dados && itens.length > 0 ? (
          <>
            <div className="cr-detail-actions">
              <div className="cr-detail-count">
                {fmtInt(itens.length)} {ROTULO_TIPO[tipo] || "item(ns)"}
                {total > itens.length ? ` de ${fmtInt(total)} (mostrando os primeiros)` : ""}
              </div>
              {abrirAuditoria && (tipo === "cte" || tipo === "duplicado") ? (
                <button type="button" className="cr-link-btn" onClick={() => abrirAuditoria("cte")}>
                  Abrir na Auditoria de CT-e
                </button>
              ) : null}
            </div>
            {tipo === "cte" ? <CteTable itens={itens} mostrarSimulado={mostrarSimulado} abrirAuditoria={abrirAuditoria} /> : null}
            {tipo === "pedido" ? <PedidoTable itens={itens} abrirAuditoria={abrirAuditoria} /> : null}
            {tipo === "nf" ? <NfTable itens={itens} abrirAuditoria={abrirAuditoria} /> : null}
            {tipo === "duplicado" ? <DuplicadoTable itens={itens} /> : null}
            {tipo === "cobertura" ? <CoberturaTable itens={itens} /> : null}
          </>
        ) : null}
      </div>
    </Modal>
  );
}
